import { render, staticRenderFns } from "./transferAuth.vue?vue&type=template&id=7b3ed0b7&scoped=true&"
import script from "./transferAuth.vue?vue&type=script&lang=js&"
export * from "./transferAuth.vue?vue&type=script&lang=js&"
import style0 from "./transferAuth.vue?vue&type=style&index=0&id=7b3ed0b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3ed0b7",
  null
  
)

export default component.exports